if (!customElements.get('footer-section')) {
  customElements.define(
    'footer-section',
    class FooterSection extends HTMLElement {
      private form!: HTMLFormElement;
      private input!: HTMLInputElement;
      private errorEl!: HTMLElement;
      private successEl!: HTMLElement;

      // Called when the element is connected to the DOM
      connectedCallback(): void {
        this.form = this.querySelector('[data-newsletter-form]') as HTMLFormElement;
        this.input = this.form?.querySelector('[data-email-form-input]') as HTMLInputElement;
        this.errorEl = this.querySelector('[data-newsletter-error]') as HTMLElement;
        this.successEl = this.querySelector('[data-newsletter-success]') as HTMLElement;
        this.addFormListener();
        const footerBanner = document.querySelector('[data-footer-banner]');
        if(window.innerWidth < 1024) {
          // Set positoin to fixed later on mobile due to CLS time
          setTimeout(() => {
            footerBanner?.classList.add('!fixed')
          }, 4000);
        } else {
          footerBanner?.classList.add('!fixed')  
        }
      }

      // Validates an email address using a regular expression
      private validateEmail(email: string): boolean {
        const regex = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
        return regex.test(email);
      }

      // Handles the subscription request
      private async submitSubscriptionRequest(userEmail: string): Promise<Response> {
        const klaviyo = window['DEPT']?.klaviyo;
        if (!klaviyo?.emailListId) {
          throw new Error('Klaviyo Email List ID is not set');
        }
        const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${klaviyo.apiKey}`;
        const payload = {
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: userEmail,
                    properties: {},
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: 'SUBSCRIBED',
                        },
                      },
                    },
                  },
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: klaviyo.emailListId,
                },
              },
            },
          },
        };
        const options = {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            revision: '2025-01-15',
            'content-type': 'application/vnd.api+json',
          },
          body: JSON.stringify(payload),
        };

        return await fetch(url, options);
      }

      // Adds a submit event listener to the newsletter form
      private addFormListener(): void {
        if (!this.form || !this.input) return;
        this.form.addEventListener('submit', async (event: Event) => {
          event.preventDefault();
          event.stopImmediatePropagation();

          this.errorEl.classList.add('hidden');
          this.successEl.classList.add('hidden');

          const userEmail = this.input.value;
          if (!this.validateEmail(userEmail)) {
            this.errorEl.textContent = 'Invalid email address. Please check and try again.';
            this.errorEl.classList.remove('hidden');
            return;
          }

          try {
            const response = await this.submitSubscriptionRequest(userEmail);
            if (!response.ok) {
              this.errorEl.textContent = 'Error submitting subscription. Please try again later.';
              this.errorEl.classList.remove('hidden');
              console.error('Error submitting subscription', response);
            } else {
              this.successEl.classList.remove('hidden');
              this.input.value = '';
            }
          } catch (err) {
            this.errorEl.textContent = 'Network error. Please try again later.';
            this.errorEl.classList.remove('hidden');
            console.error('Network error:', err);
          }
        });
      }
    }
  );
}
